import React from 'react';

function Modal({ isOpen, onClose, children, title }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.4)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 2000
    }}>
      <div className="modal-content" style={{
        backgroundColor: "white",
        borderRadius: "0.5rem",
        maxWidth: "1200px", // Increased from 800px
        width: "95%", // Increased from 90%
        maxHeight: "95vh", // Increased from 90vh
        overflowY: "auto",
        animation: "fadeIn 0.3s"
      }}>
        <div className="modal-header" style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "1.5rem",
          borderBottom: "1px solid var(--border-color)"
        }}>
          {title && <h2 className="modal-title">{title}</h2>}
          <span 
            className="close-btn" 
            onClick={onClose}
            style={{ 
              cursor: "pointer", 
              fontSize: "28px",
              fontWeight: "bold",
              color: "#aaa"
            }}
          >&times;</span>
        </div>
        <div className="modal-body" style={{ padding: "1rem" }}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default Modal;


